import { Component, input } from '@angular/core';
import { RangedKanaalAssign } from '../../props/PropTypes';
import { rangedKanaalLabel } from '../kanaal.utils';

@Component({
  selector: 'hdw-io-list',
  templateUrl: './hdw-io-list.component.html',
  styleUrl: './hdw-io-list.component.scss'
})
export class HdwIoListComponent {
  public ios = input.required<RangedKanaalAssign[]>();

  public label = input<string>("");


  public kanaalLabel(a: RangedKanaalAssign) {
    return rangedKanaalLabel(a.rangedKnaal).split(":")[1];
  }

}
